import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Animated, Easing, View } from 'react-native';
import { getTestId, IconButton, Typography, isValidObject } from '@airtel/air-design-system';
import { getOnboardingAnimatedWidgetStyles } from './OnboardingAnimatedWidgetStyles';
export var OnboardingAnimatedWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OnboardingAnimatedWidget' : _props$testID,
    data = props.data,
    textContainerStyles = props.textContainerStyles,
    imageContainerStyles = props.imageContainerStyles,
    _props$animationTime = props.animationTime,
    animationTime = _props$animationTime === void 0 ? 2500 : _props$animationTime,
    style = props.style;
  var _useState = useState(0),
    currentIndex = _useState[0],
    setCurrentIndex = _useState[1];
  var fadeAnim = useRef(new Animated.Value(1)).current;
  var styles = getOnboardingAnimatedWidgetStyles();
  useEffect(() => {
    var interval;
    if (animationTime > 0 && isValidObject(data)) {
      interval = setTimeout(() => {
        animateTransition(fadeAnim, setCurrentIndex, data);
      }, animationTime);
    }
    return () => clearInterval(interval);
  }, []);
  return _jsx(View, Object.assign({}, getTestId(testID), {
    style: [styles.defaultMainContainerStyle, style]
  }, {
    children: isValidObject(data) && _jsxs(Animated.View, Object.assign({
      style: {
        opacity: fadeAnim
      }
    }, {
      children: [renderIconButtons(styles.imageIconContainerdefaultStyle, imageContainerStyles, data, currentIndex), renderTypographyTexts(styles.textContainerdefaultStyle, data, currentIndex, textContainerStyles)]
    }))
  }));
};
var animateTransition = (fadeAnim, setCurrentIndex, data) => {
  Animated.timing(fadeAnim, {
    toValue: 0,
    duration: 500,
    easing: Easing.ease,
    useNativeDriver: true
  }).start(() => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % (data === null || data === void 0 ? void 0 : data.length) || 0);
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 500,
      easing: Easing.ease,
      useNativeDriver: true
    }).start();
  });
};
var renderIconButtons = (imageIconContainerdefaultStyle, imageContainerStyles, data, currentIndex) => {
  var _a, _b;
  return _jsx(View, Object.assign({
    style: [imageIconContainerdefaultStyle, imageContainerStyles]
  }, {
    children: (_b = (_a = data[currentIndex]) === null || _a === void 0 ? void 0 : _a.icon) === null || _b === void 0 ? void 0 : _b.map(item => _jsx(IconButton, Object.assign({}, item)))
  }));
};
var renderTypographyTexts = (textContainerdefaultStyle, data, currentIndex, textContainerStyles) => {
  var _a, _b;
  return _jsx(_Fragment, {
    children: _jsx(View, Object.assign({
      style: [textContainerdefaultStyle, textContainerStyles]
    }, {
      children: (_b = (_a = data[currentIndex]) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b.map(item => _jsx(Typography, Object.assign({}, item)))
    }))
  });
};
OnboardingAnimatedWidgetComponent.genericRendererKey = 'AirOnboardingAnimatedWidget';